import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { DesignMagazinePlanArticleI18nEditPresenter } from "./presenter";
import { usePlanI18nArticleQuery } from "../../model/repository/query/use-plan-query";

type Props = {
	hotelID: string;
	planID: string;
	langCode: LangCode;
};

export const DesignMagazinePlanArticleI18nEditContainer = memo(({ hotelID, planID, langCode }: Props) => {
	const { data } = usePlanI18nArticleQuery({ hotelID, planID, langCode });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<DesignMagazinePlanArticleI18nEditPresenter hotelID={hotelID} planID={planID} langCode={langCode} data={data} />
	);
});

DesignMagazinePlanArticleI18nEditContainer.displayName = "DesignMagazinePlanArticleI18nEdit";
